export default {
  // 「YYYY/MM/DD」の配列
  displayDates: [],
  selectedTaskId: null,
  selectedColumnKey: null,
  summaryDialogShowPopup: false,

  masterMap: {},
  destinationWorkTasksMap: {
    // <YYYYMMDD>: destinationWorkTasks
  },
  lastUpdatedTimeMap: {},

  lastUpdatedForMasters: -1,
  lastUpdatedForTasks: -1,

  firestoreSubscribeList: [],
  // 黒画面（入出港予定一覧表）に表示する日付
  selectedDate: "",
  // 黒画面（入出港予定一覧表）に表示する task の property によるフィルタ
  // 画面操作で明示的に設定したものを保持
  storedFilterRule: {
    //     "port_id": {
    //        [key: `${port_id}`]: boolean
    //     }
  },
  presentColumnsFilteringState: {},
};
